<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - P-Anfrage</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--producer-quote">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">

                <div class="container">
                    <form @submit.prevent="submit" class="row">
                        <div class="col col-3">
                            <card>
                                <card-header>
                                    <card-overline>Neue Anfrage</card-overline>
                                </card-header>
                                <card-content>
                                    <form-input id="delivery_date"
                                                label="gewünschter Liefertermin vom Kunden"
                                                disabled="disabled" v-model="form.delivery_date"
                                                :error="form.errors.delivery_date" placeholder="keine Angabe vom Kunden"/>
                                    <form-input id="delivery_days_for_producer"
                                                label="P-Lieferzeit in Tagen"
                                                disabled="disabled" v-model="form.delivery_days_for_producer"
                                                :error="form.errors.delivery_days_for_producer"/>

                                    <form-input id="new_delivery_days_for_producer"
                                                label="neue P-Lieferzeit in Tagen"
                                                v-model="form.new_delivery_days_for_producer"
                                                :error="form.errors.new_delivery_days_for_producer"/>
                                </card-content>
                            </card>
                            <card>
                                <card-header>
                                    <card-overline>Kundenkommentar</card-overline>
                                </card-header>
                                <card-content>
                                    <p>{{ clientComment }}</p>
                                </card-content>
                            </card>
                            <card>
                                <card-header>
                                    <card-overline>Bietrunde</card-overline>
                                </card-header>
                                <card-content>
                                    <form-select id="bid_round_duration" label="Dauer der Bietrunde"
                                                 v-model="form.bid_round_duration"
                                                 :options="this.bidRoundDurations" @change="setBitRoundEnd">
                                    </form-select>
                                    <form-input id="ending_at" label="Ende der Bietrunde"
                                                v-model="form.ending_at" disabled="disabled"/>
                                    <form-checkbox id="send_collected" label="Sammelmailing"
                                                   v-model:checked="form.send_collected"
                                                   option="Anfrage gesammelt verschicken" />
                                </card-content>
                            </card>
                            <card>
                                <card-header>
                                    <card-overline>Stückzahl / Angebotsgültigkeit</card-overline>
                                </card-header>
                                <card-content>
                                    <form-inline>
                                        <label for="lotqty_1">Stückzahl</label>
                                        <form-input id="lotqty_1" v-model="form.lotqty_1"
                                                    :error="form.errors.lotqty_1"/>
                                        <form-input id="lotqty_2" v-model="form.lotqty_2"
                                                    :error="form.errors.lotqty_2"/>
                                        <form-input id="lotqty_3" v-model="form.lotqty_3"
                                                    :error="form.errors.lotqty_3"/>
                                        <form-input id="lotqty_4" v-model="form.lotqty_4"
                                                    :error="form.errors.lotqty_4"/>
                                        <span class="form-info">(Bei Baugruppen Gesamtstückzahl angeben!)</span>
                                    </form-inline>
                                    <form-input id="p_custom_offer_validity"
                                                v-model="form.p_custom_offer_validity"
                                                label="P-Angebotsgültigkeit"
                                                :error="form.errors.p_custom_offer_validity"/>
                                    <form-input id="c_custom_offer_validity"
                                                v-model="form.c_custom_offer_validity"
                                                label="K-Angebotsgültigkeit"
                                                :error="form.errors.c_custom_offer_validity"/>
                                </card-content>
                            </card>
                        </div>
                        <div class="col col-9">
                            <div class="row">
                                <div class="col">
                                    <card>
                                        <card-header>
                                            <card-overline>Produzenten auswählen</card-overline>
                                        </card-header>
                                        <card-content>
                                            <div class="producer-inline-actions">
                                                <form-button type="button" @click="selectBestMatchedProducer">Übereinstimmungen auswählen</form-button>
                                                <form-button type="button" @click="selectNoFeedbackProducer">Prod. ohne Rückmeldung auswählen</form-button>
                                                <form-input id="prod" placeholder="Produzent aus Vorgang übernehmen" v-model="selectAskForQuoteProducerForm.pfnumber" v-on:keyup.enter="selectAskForQuoteProducer"/>
                                                <form-button type="button" color="secondary" @click="selectAskForQuoteProducer">übernehmen</form-button>
                                            </div>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row" v-if="form.errors.producer_user">
                                <div class="col">
                                    <card class="error">
                                        <card-content>
                                            Es muss mindestens ein Produzent ausgewählt werden.
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <card>
                                        <card-header>
                                            <card-overline>Produzenten</card-overline>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--stripped table--card table--th-middle">
                                                <thead>
                                                <tr>
                                                    <th>
                                                        <form-checkbox id="checkProducer"
                                                                       v-model:checked="checkProducer"
                                                                       @update:checked="setCheckProducer"/>
                                                    </th>
                                                    <th>P-Nr</th>
                                                    <th>Firma</th>
                                                    <th>Land</th>
                                                    <th>Übereinstimmung</th>
                                                    <th>Ranking</th>
                                                    <th>Anzahl Anfragen</th>
                                                    <th>Rückmeldung</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="producer in availableProducer" :key="producer.index">
                                                    <td>
                                                        <form-checkbox :id="'prod-'+producer.id"
                                                                       v-model:checked="form.producer_user[producer.id]"/>
                                                    </td>
                                                    <td>{{ producer.prod_no }}</td>
                                                    <td>{{ producer.company }}</td>
                                                    <td>{{ producer.producer_country.country_name }}</td>
                                                    <td><span :title="producer.matched_methods_string + ' ('+producer.not_matched_methods_string+')'">
                                                            {{ producer.matched_methods_count }} von
                                                            {{ producer.not_matched_methods_count }}
                                                        </span> / <span :title="producer.matched_materials_string + ' ('+producer.not_matched_materials_string+')'">
                                                            {{ producer.matched_materials_count }} von
                                                            {{ producer.not_matched_materials_count }}
                                                        </span>
                                                    </td>
                                                    <td>{{ producer.ranking }}</td>
                                                    <td>{{ producer.bid_round_members_count }}</td>
                                                    <td>{{ producer.bid_round_members_feedback_count > 0 ? 'Ja' : 'Nein' }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row row--sticky" v-sticky>
                                <div class="col">
                                    <form-actions>
                                        <form-button type="submit" color="secondary" icon="button-arrow-right-circle"
                                                     class="btn--block" :disabled="disabledTab || form.processing" :class="{'btn--processing': form.processing}">Anfrage absenden
                                        </form-button>
                                    </form-actions>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row" v-if="bidRounds.length">
                        <div class="col">
                            <bid-rounds :bid-rounds="bidRounds" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormInline from '@partfactory/Shared/Form/FormInline';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormActions from '@partfactory/Shared/Form/FormActions';
import axios from 'axios';
import BidRounds from '@partfactory/Pages/Admin/AskForQuote/ProducerQuote/BidRounds';

export default {
    name: 'ProducerQuote',
    components: {
        BidRounds,
        FormActions,
        FormButton,
        FormCheckbox,
        FormSelect,
        FormInline, FormInput, CardContent, CardOverline, CardHeader, Card, AskForQuoteHeader, AppAdminLayout
    },
    props: {
        askForQuote: Object,
        producerUser: Object,
        abilities: Object,
    },
    data() {
        const bidRoundDurations = [], endingAt = null, checkProducer = false;

        bidRoundDurations.push({text: '48 Stunden, Ende 9:00 Uhr', value: 'default'});

        for (let i = 1; i < 256; i++) {
            bidRoundDurations.push({text: i === 1 ? i + ' Stunde' : i + ' Stunden', value: i});
        }

        const form = useForm({
            delivery_date: this.askForQuote.delivery_date ? this.$moment(String(this.askForQuote.delivery_date)).format('DD.MM.YYYY') : null,
            delivery_days_for_producer: null,
            new_delivery_days_for_producer: null,
            lotqty_1: this.askForQuote.lotqty_1,
            lotqty_2: this.askForQuote.lotqty_2,
            lotqty_3: this.askForQuote.lotqty_3,
            lotqty_4: this.askForQuote.lotqty_4,
            bid_round_duration: 'default',
            ending_at: null,
            p_custom_offer_validity: this.$page.props.factors.p_custom_offer_validity,
            c_custom_offer_validity: this.$page.props.factors.c_custom_offer_validity,
            send_collected: true,
            producer_user: {},
        });

        const selectAskForQuoteProducerForm = useForm({
            pfnumber: null,
        });

        return {bidRoundDurations, endingAt, checkProducer, form, selectAskForQuoteProducerForm};
    },
    computed: {
        availableProducer() {
            let availableProducer = this.producerUser;

            availableProducer.forEach(producer => {
                this.abbilitiesMatching(producer);
            });

            return availableProducer;
        },
        bidRounds() {
            let bidRounds = this.askForQuote.bid_rounds;

            bidRounds.forEach(bidRound => {
                bidRound.bid_round_members.forEach(bidRoundMember => {
                    this.abbilitiesMatching(bidRoundMember.producer_user);
                });
            });

            return bidRounds;
        },
        clientComment() {
            return this.askForQuote.client_user.comment;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99) || this.askForQuote.status < 3;
        },
    },
    methods: {
        abbilitiesMatching(producer) {
            let matched_methods = [], not_matched_methods = [], matched_materials = [], not_matched_materials = [];
            for (const [ab_key] of Object.entries(this.abilities.methods)) {
                this.abilities.methods[ab_key].forEach((method) => {
                    if (producer.matched_abilities?.methods?.[ab_key]?.[method[0]] === true) {
                        matched_methods.push(method[1]);
                    }
                    if (producer.not_matched_abilities?.methods?.[ab_key]?.[method[0]] === false) {
                        not_matched_methods.push(method[1]);
                    }
                });
            }
            producer.matched_methods_count = matched_methods.length;
            producer.not_matched_methods_count = matched_methods.length + not_matched_methods.length;

            producer.matched_methods_string = matched_methods.join(', ');
            producer.not_matched_methods_string = not_matched_methods.join(', ');

            this.abilities.materials.forEach((material) => {
                if (producer.matched_abilities?.materials?.[material[0]] === true) {
                    matched_materials.push(material[1]);
                }
                if (producer.not_matched_abilities?.materials?.[material[0]] === false) {
                    not_matched_materials.push(material[1]);
                }
            });

            producer.matched_materials_count = matched_materials.length;
            producer.not_matched_materials_count = matched_materials.length + not_matched_materials.length;

            producer.matched_materials_string = matched_materials.join(', ');
            producer.not_matched_materials_string = not_matched_materials.join(', ');

            return producer;
        },

        setBitRoundEnd() {

            // prüfen ob startpunkt arbeitstag und kein urlaubstag ist, sonst nächsten Werktag nehmen
            // bei default min Duration, Ende um 09:00 Uhr
            if (this.$moment().isBusinessDay() && !this.$moment().isHoliday()) {
                if (this.form.bid_round_duration === 'default') {
                    this.endingAt = this.$moment().add(Number(this.$page.props.factors.min_bid_round_duration) + 1, 'hours').set({'hour': 9, 'minute': 0, 'second': 0, 'millisecond': 0});
                } else {
                    this.endingAt = this.$moment().add(Number(this.form.bid_round_duration) + 1, 'hours');
                }
            } else {
                if (this.form.bid_round_duration === 'default') {
                    this.endingAt = this.$moment().nextBusinessDay().add(Number(this.$page.props.factors.min_bid_round_duration) + 1, 'hours').set({'hour': 9, 'minute': 0, 'second': 0, 'millisecond': 0});
                } else {
                    this.endingAt = this.$moment().nextBusinessDay().add(Number(this.form.bid_round_duration) + 1, 'hours');
                }
            }

            // prüfen ob endpunkt arbeitstag oder urlaubstag ist, sonst nächsten Werktag nehmen
            if (!this.endingAt.isBusinessDay() || this.endingAt.isHoliday()) {
                // auf nächsten Werktag springen
                this.endingAt = this.endingAt.nextBusinessDay();

                // // wenn default und Freitag auf Dienstag 09:00 Uhr springen
                if (this.$moment().day() === 5 && this.form.bid_round_duration === 'default') {
                    this.endingAt.nextBusinessDay();
                }
            }
            this.form.ending_at = this.endingAt.format('DD.MM.YYYY, HH') + ':00 Uhr';

            this.setDeliveryDaysForProducer();
        },
        setDeliveryDaysForProducer() {

            // no delivery data from client = 5 Tage
            if (this.askForQuote.delivery_date === null) {
                this.form.delivery_days_for_producer = this.$page.props.factors.delivery_time_producer_part;
            } else {
                // delivery_time_part_client = 2 Tage
                // Liefertermin - 2 Tage
                let deliveryDaysForPartfactory = this.$moment(String(this.askForQuote.delivery_date))
                    .businessSubtract(Number(this.$page.props.factors.delivery_time_part_client))._d;

                if (!this.$moment(deliveryDaysForPartfactory).isBusinessDay() || this.$moment(deliveryDaysForPartfactory).isHoliday()) {
                    deliveryDaysForPartfactory = this.$moment(deliveryDaysForPartfactory).nextBusinessDay();
                }

                // Tage zwischen Ende Bietrunde und Partfactory an Kunde oder 5 Tage aus Config
                return this.form.delivery_days_for_producer = this.$moment(deliveryDaysForPartfactory).nextBusinessDay().diff(this.endingAt, 'days', false) > this.$page.props.factors.delivery_time_producer_part ?
                    this.$moment(deliveryDaysForPartfactory).nextBusinessDay().diff(this.endingAt, 'days', false) : this.$page.props.factors.delivery_time_producer_part;
            }
        },
        setCheckProducer() {
            this.producerUser.forEach((producer) => {
                this.form.producer_user[producer.id] = this.checkProducer;
            });
        },
        selectBestMatchedProducer($event, reduceMatches = 0) {
            const bestMatchedProducer = this.producerUser.filter((producer) => {
                return producer.matched_methods_count === (producer.not_matched_methods_count - reduceMatches)  && producer.matched_methods_count !== 0;
            });

            if (bestMatchedProducer.length === 0) {
                this.selectBestMatchedProducer($event, reduceMatches + 1);
            }

            bestMatchedProducer.forEach(producer => {
                this.form.producer_user[producer.id] = true;
            });
        },
        selectNoFeedbackProducer() {

            const bidRounds = this.askForQuote.bid_rounds;
            let noFeedbackProducer = [];

            bidRounds.forEach((bidRound) => {
                const noFeedbackMember = bidRound.bid_round_members.filter((member) => {
                    return member.offer_given === false && member.rejected === false;
                });

                noFeedbackProducer.push(...noFeedbackMember);
            });

            noFeedbackProducer.forEach(producer => {
                this.form.producer_user[producer.producer_user_id] = true;
            });
        },
        selectAskForQuoteProducer() {
            const url = this.$$route('ask-for-quote.producer-quote.find.producer', {'askForQuote': this.askForQuote.id});
            let formData = new FormData(); // pass data as a form
            formData.append('pfnumber', this.selectAskForQuoteProducerForm.pfnumber);
            axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': this.$page.props.csrf_token,
                    },
                })
                .then((response) => {
                    this.selectAskForQuoteProducerForm.pfnumber = null;

                    response.data.producerUser.forEach(producerUser => {
                        this.form.producer_user[producerUser.producer_user_id] = true;
                    });

                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.msg);
                    }
                });
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    ending_at: this.form.ending_at.replace(' Uhr', ''),
                    send_collected: this.form.send_collected ? '1' : '0',
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.producer-quote.post', {'askForQuote': this.askForQuote.id}), {
                    preserveScroll: false,
                    onSuccess: () => {
                        this.checkProducer = false;
                        this.form.reset();
                        this.setBitRoundEnd();
                    },
                });
        }
    },
    mounted() {
        this.setBitRoundEnd();

        this.producerUser?.forEach((producer) => {
            this.form.producer_user[producer.id] = false;
        });
    },
};
</script>
